import { MassActionCheckCellProps } from 'components/common/grid/';
import { Cell } from 'rsuite-table';
import { Checkbox, Grid } from '@mui/material';
import { SxProps } from '@mui/system';
import { useMemo } from 'react';

export default function MassActionCheckCell({
    rowData,
    onChange,
    dataKey,
    column,
    checkedRowsKeys,
    uid,
    ...props
}: MassActionCheckCellProps) {
    const gridProps: SxProps = { height: 1, alignItems: 'center', justifyContent: 'right', position: 'relative' };

    const isChecked = useMemo(() => {
        if (checkedRowsKeys) {
            return checkedRowsKeys.some((item) => item == rowData[dataKey]);
        }
        return false;
    }, [checkedRowsKeys, rowData?.[dataKey]]);

    return (
        <Cell {...props} className={`rs-table-cell--checkbox ${isChecked ? 'rs-table-cell--selected-row' : ''}`}>
            <Grid container sx={gridProps} className={'checkbox-holder disabled-checkbox-cursor-mod--not-allowed'}>
                <Checkbox
                    data-test={`grid_${uid}_checkbox_column_check_${rowData[dataKey]}`}
                    sx={{ padding: 0 }}
                    value={rowData[dataKey]}
                    onChange={onChange}
                    checked={isChecked}
                    disabled={Boolean(rowData['unselectable'])}
                />
            </Grid>
        </Cell>
    );
}
